export default {
  en: {
    permissionDeniedMessage:
      'We regret to inform you that you do not have the necessary permissions to view this content. If you believe this is an error, please contact an admin for further assistance.',
  },
  es: {},
  fr: {},
  de: {},
};
